export default function MarginReport() {
  return (
    <div className="erp-page-grid">
      <h2>Margin Report</h2>
    </div>
  );
}